import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

export interface PropertyResult {
  id: string;
  source: string;
  address: string;
  price: number;
  area: number;
  frontage: number; // 接道間口
  estimatedRooms: number;
  estimatedYield: number;
  status: '合格' | '要確認' | '見送り';
}

const MOCK_DATA: PropertyResult[] = [
  { id: '1', source: 'SUUMO', address: '足立区千住...', price: 3500, area: 120, frontage: 8.5, estimatedRooms: 8, estimatedYield: 7.5, status: '合格' },
  { id: '2', source: 'HOME\'S', address: '葛飾区立石...', price: 4200, area: 150, frontage: 6.2, estimatedRooms: 8, estimatedYield: 6.8, status: '要確認' },
  { id: '3', source: '三井のリハウス', address: '江戸川区...', price: 2800, area: 90, frontage: 5.5, estimatedRooms: 6, estimatedYield: 8.1, status: '合格' },
  { id: '4', source: 'SUUMO', address: '世田谷区...', price: 8500, area: 100, frontage: 4.0, estimatedRooms: 4, estimatedYield: 4.2, status: '見送り' }
];

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['source', 'address', 'price', 'area', 'frontage', 'estimatedRooms', 'estimatedYield', 'status', 'actions'];
  dataSource: MatTableDataSource<PropertyResult>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor() {
    this.dataSource = new MatTableDataSource(MOCK_DATA);
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}